import { GridRowEditEndedEventArgs as GridRowEditEndedEventArgs_internal } from "./GridRowEditEndedEventArgs";
var IgrGridRowEditEndedEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridRowEditEndedEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrGridRowEditEndedEventArgs.prototype.createImplementation = function () {
        return new GridRowEditEndedEventArgs_internal();
    };
    Object.defineProperty(IgrGridRowEditEndedEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrGridRowEditEndedEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrGridRowEditEndedEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrGridRowEditEndedEventArgs.prototype, "row", {
        /**
         * Gets the row that ended editing.
        */
        get: function () {
            return this.i.a;
        },
        set: function (v) {
            this.i.a = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrGridRowEditEndedEventArgs.prototype, "item", {
        /**
         * Gets the row item.
        */
        get: function () {
            return this.i.item;
        },
        set: function (v) {
            this.i.item = v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrGridRowEditEndedEventArgs;
}());
export { IgrGridRowEditEndedEventArgs };
//# sourceMappingURL=igr-grid-row-edit-ended-event-args.js.map
